import { render, staticRenderFns } from "./videoTrainingManage.vue?vue&type=template&id=d48526bc&scoped=true&"
import script from "./videoTrainingManage.vue?vue&type=script&lang=js&"
export * from "./videoTrainingManage.vue?vue&type=script&lang=js&"
import style0 from "./videoTrainingManage.vue?vue&type=style&index=0&id=d48526bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48526bc",
  null
  
)

export default component.exports